<template>
	<div class="serve">
		<div style="width: 80%; margin: 0 auto">
			<div class="mb-tabs">
				<el-tabs v-model="activeTitle" @tab-click="checkTab">
					<div></div>
					<el-tab-pane v-for="(tab, idx) in tabsList" :key="idx" :name="tab.id + ''">
						<template slot="label">
							<el-tooltip
								:content="tab.describe"
								placement="bottom"
								effect="light"
								popper-class="tooltip_class"
								:visible-arrow="false"
							>
								<div>
									<div class="label-img">
										<img :src="tab.img" />
									</div>
									<div class="label-title">{{ tab.name }}</div>

									<div class="label-font">{{ tab.describe }}</div>
								</div>
							</el-tooltip>
						</template>
					</el-tab-pane>
					<!-- <el-tab-pane label="配置管理" name="second">
						<template slot="label">
							<div class="label-img">
								<img src="../../assets/images/icon7.png" />
							</div>
							<div class="label-title">上门实施</div>
							<div class="label-font">致力于打造高效的管理<br />方法和解决方案</div>
						</template>
					</el-tab-pane> -->
				</el-tabs>
			</div>
			<div>
				<!-- <el-carousel :interval="5000" height="260px" arrow="always"> -->
				<!-- <div style=" background: red;"> -->
				<div style="display: flex; justify-content: space-around; height: 260px">
					<div class="shop-card" v-for="(card, idx) in cardList" :key="idx" :class="classAry[idx]">
						<div>
							<div class="fs24 mgb10 textc">
								<b>{{ card.name }}</b>
							</div>
							<div class="cen">
								<div class="card-title">加购包包含<span></span></div>
								<div class="card-content">：{{ card.haveContent }}</div>
							</div>
							<div class="mb10 cen">
								<div class="card-title">售价<span></span></div>
								<div class="card-content">
									：￥<span class="fs24">{{ card.price }}</span
									>/{{ card.priceUnit }}
								</div>
							</div>
							<div class="cen" v-if="Number(card.renewPrice)">
								<div class="card-title">续费<span></span></div>
								<div class="card-content">
									：￥<span class="fs24">{{ card.renewPrice }}</span
									>/{{ card.priceUnit }}
								</div>
							</div>
							<div class="textc" style="margin-top: 5px">
								<el-button
									size="small"
									style="background: #e69752; border: none; color: white"
									@click="buyBtn(card.id)"
									>点击购买</el-button
								>
							</div>
						</div>
					</div>
				</div>
				<!-- </div> -->
				<!-- </el-carousel> -->
			</div>
		</div>
	</div>
</template>

<script>
import { editions } from '@/utils/api'
import { mabangPay } from '@/utils/constant'
export default {
	data() {
		return {
			tabsList: [],
			classAry: ['bg1', 'bg2', 'bg1', 'bg2'],
			cardList: [],
			activeTitle: null,
		}
	},
	mounted() {
		this.getTabs()
	},
	methods: {
		getTabs() {
			let params = {
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			editions(params).then((res) => {
				this.tabsList = [...res]
				if (this.$route.query.editionId) {
					this.activeTitle = this.$route.query.editionId + ''
					this.tabsList.forEach((item) => {
						if (item.id == this.$route.query.editionId) {
							this.cardList = [...item.list]
						}
					})
				} else {
					this.activeTitle = this.tabsList[0].id + ''
					this.cardList = [...res[0].list]
				}
			})
		},
		checkTab() {
			let obj = this.tabsList.filter((item) => item.id == this.activeTitle)
			this.cardList = [...obj[0].list]
		},
		buyBtn(goodsId) {
			let params = {
				goodsId: goodsId,
				buyNum: 1,
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
			}
			mabangPay(params)
		},
	},
}
</script>

<style scoped>
.el-carousel__item h3 {
	color: black;
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}

.shop-card {
	width: 35%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.bg1 {
	background: url('~@/assets/images/bg1.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: black;
}

.bg2 {
	background: url('~@/assets/images/bg2.png') no-repeat 0 0;
	background-size: 100% 100%;
	color: #e9bd9c;
}
</style>
